// extracted by mini-css-extract-plugin
export default {"dialogHeaderContainer":"SimpleDialog_dialogHeaderContainer__jvMQC","dialogTitle":"SimpleDialog_dialogTitle__KIy1I","dialogAction":"SimpleDialog_dialogAction__3Xsl7"};